import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Button from "../../../../components/Common/Button/Button";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import Input from "../../../../components/Common/Input/Input";
import { useFetchData } from "../../../../hooks/useFetchData";
import {
  getAllNotificationHistoryActionHandler,
  getNotificationHistoryCSVActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/engagementCenterActionHandler";
import { notificationHistory } from "../../../../utils/mainTabs/admin/engagementCenter/notificationHistory";
import { notificationHistorySchema } from "../../../../utils/mainTabs/admin/engagementCenter/notificationHistorySchema";
import classes from "./NotificationHistory.module.scss";
import { FormattedMessage, injectIntl } from "react-intl";
const NotificationHistory = ({intl}) => {
  const dispatch = useDispatch();
  const pageSize = 8;

  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(notificationHistorySchema),
  });
  const {
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = methods;

  const [minEndDate, setMinEndDate] = useState(null);
  const [maxStartDate, setMaxStartDate] = useState(
    new Date().toJSON().split("T")[0]
  );

  const { columns } = notificationHistory;

  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    searchQuery,
    handleCurrentPage,
    handleSearchQuery,
    handleSetOptionalParams,
  } = useFetchData(getAllNotificationHistoryActionHandler, pageSize);

  const handleStartDate = (e) => {
    if (e.target.value) setMinEndDate(e.target.value);
  };

  const handleEndDate = (e) => {
    if (e.target.value) setMaxStartDate(e.target.value);
  };

  const handleNotificationDownload = (data) => {
    dispatch(
      getNotificationHistoryCSVActionHandler(data?.NotificationId, data?.Id)
    );
  };

  // function formatDate(date, isStart) {
  //   var d = new Date(date),
  //     month = "" + (d.getMonth() + 1),
  //     day = "" + d.getDate(),
  //     year = d.getFullYear();

  //   if (month.length < 2) month = "0" + month;
  //   if (day.length < 2) day = "0" + day;
  //   // year = isStart ? year + " " : year;
  //   // day = isStart ? day : " " + day;
  //   return [year, month, day].join("/");
  // }
  const handleReset = () => {
    reset();
    handleSetOptionalParams(null, null);
  };

  const onSubmit = (data) => {
    const startDate = encodeURIComponent(
      new Date(data.startDate).toLocaleDateString()
    );
    const endDate = encodeURIComponent(
      new Date(data.endDate).toLocaleDateString()
    );
    // const startDate = encodeURIComponent(formatDate(data.startDate));
    // const endDate = encodeURIComponent(formatDate(data.endDate));
    handleSetOptionalParams(startDate, endDate);
  };

  return (
    <div className={classes.notificationHistory}>
      <div className={classes.notificationHistory__header}>
        <div className={classes.notificationHistory__header__count}>
          {totalRows || 0} <FormattedMessage id="NOTIFICATION_TEXT" />
        </div>
        <FormProvider {...methods}>
          <form
            className={classes.notificationHistory__header__actionContainer}
            onSubmit={handleSubmit(onSubmit)}
          >
            <Input
              label={<FormattedMessage id="NOTIFICATION_START_DATE" />}
              direction="row"
              name="startDate"
              placeholder={intl.formatMessage({
                id: `P_START_DATE`,
              })}
              labelColor="light"
              error={errors?.startDate?.message}
              required
              type="date"
              max={maxStartDate}
              width="20"
              height="4"
              borderRadius="0.5"
              onChange={handleStartDate}
            />
            <Input
              label={<FormattedMessage id="P_END_DATE" />}
              direction="row"
              name="endDate"
              placeholder={intl.formatMessage({
                id: `P_END_DATE`,
              })}
              labelColor="light"
              error={errors?.endDate?.message}
              required
              type="date"
              min={minEndDate}
              max={new Date().toJSON().split("T")[0]}
              width="20"
              height="4"
              borderRadius="0.5"
              onChange={handleEndDate}
            />
            <div
              className={
                classes.notificationHistory__header__actionContainer__reset
              }
              onClick={handleReset}
            >
              <FormattedMessage id="RESET_MSG" />
            </div>
            <Button
              label={<FormattedMessage id="APPLY" />}
              dark
              type="submit"
              disabled={!isValid}
              width="10"
              height="4"
              borderRadius="0.5"
            />
          </form>
        </FormProvider>
      </div>
      <DataTable
        columns={columns(handleNotificationDownload)}
        defaultData={data}
        setDefaultData={setData}
        data={updatedData}
        setData={setUpdatedData}
        totalRows={totalRows}
        loading={loading}
        uniqueFieldName={"Id"}
        fetchMoreData={handleCurrentPage}
        searchable
        searchQuery={searchQuery}
        setSearchQuery={handleSearchQuery}
      />
    </div>
  );
};

export default injectIntl(NotificationHistory);
